import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-11071306")
const _hoisted_1 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Denied ", -1)
const _hoisted_5 = { class: "_main" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Missing lobby", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Sorry, this lobby does not exist. ", -1)
const _hoisted_8 = { class: "_giveMeSpace" }
const _hoisted_9 = { class: "_header" }
const _hoisted_10 = { class: "_headerBack" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Denied ", -1)
const _hoisted_12 = { class: "_main" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "No permission", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Sorry, you do not have permission to enter this lobby. ", -1)
const _hoisted_15 = { class: "_giveMeSpace" }
const _hoisted_16 = { class: "_header" }
const _hoisted_17 = { class: "_headerBack" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Join game ", -1)
const _hoisted_19 = { class: "_main" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "_subheader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "You've found a game!"),
  /*#__PURE__*/_createElementVNode("p", null, "See the game below. Set a nickname and click join to get started!")
], -1)
const _hoisted_21 = { class: "_subheader gamePreview" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "input user" }
const _hoisted_24 = {
  key: 0,
  class: "input button"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "_subheader" }, null, -1)
const _hoisted_26 = { class: "_header" }
const _hoisted_27 = { class: "_headerBack" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Denied ", -1)
const _hoisted_29 = { class: "_main" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", null, "Duplicate player", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, " Sorry, a player with these credentials is already in the lobby. You can always join again with new credentials. ", -1)
const _hoisted_32 = { class: "_giveMeSpace" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.joinCheck)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadSpinner, { text: "Joining lobby" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.lobbyDoesntExist)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_IconButton, {
                icon: "back",
                white: true,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'})))
              })
            ]),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, [
              _createVNode(_component_IconButton, {
                text: "Join a game",
                icon: "back",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isPermitted.banned && _ctx.isPermitted.joined)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_IconButton, {
                icon: "back",
                white: true,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path:'/app'})))
              })
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("p", _hoisted_15, [
              _createVNode(_component_IconButton, {
                text: "Join a game",
                icon: "back",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
              })
            ])
          ])
        ], 64))
      : (_ctx.showJoinInputs)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_IconButton, {
                  icon: "back",
                  white: true,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({path:'/app'})))
                })
              ]),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  class: "imageMain",
                  src: `${ _ctx.game.image }`
                }, null, 8, _hoisted_22),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.game.title), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.game.shortdescription), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_TextInput, {
                  label: "Nickname",
                  default: _ctx.$store.state.Auth.user.name,
                  placeholder: "Your name",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateName($event)))
                }, null, 8, ["default"])
              ]),
              (_ctx.$store.state.Auth.user.name && _ctx.$store.state.Auth.user.name.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_IconButton, {
                      icon: "forward",
                      text: "Next",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$router.replace({path:`/app/lobby/${_ctx.game.id}/${_ctx.lobby.meta.code}`});})
                    })
                  ]))
                : _createCommentVNode("", true),
              _hoisted_25
            ])
          ], 64))
        : _createCommentVNode("", true),
    (_ctx.isConnected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_IconButton, {
                icon: "back",
                white: true,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({path:'/app'})))
              })
            ]),
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _hoisted_31,
            _createElementVNode("p", _hoisted_32, [
              _createVNode(_component_IconButton, {
                text: "Join a game",
                icon: "back",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}